import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import { Link, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import "./Events.css";

const ContactForm = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      setIsLoading(false); // Stop spinner after fetching data
    }, 1000);
  }, []);

  const noticeStyle = {
    backgroundColor: "#ebf8ff", // Light blue background
    border: "1px solid #3182ce", // Darker blue border
    color: "#2b6cb0", // Text color
    padding: "12px 16px",
    borderRadius: "8px",
    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: "20px",
    marginLeft: "10px",
    marginRight: "10px",
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  
  const NaviconStyle = {
    marginRight: '10px', // Margin between icon and text
    marginTop: '10px',
    marginLeft: '10px',
  };

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      {isLoading ? (
  <LoadingSpinner />
) : (
     <div>
<button onClick={handleRefresh} >
  <Icon icon="fa:refresh" color="black" width="17" height="17" style={NaviconStyle}/> 
    </button>
      
      <div style={noticeStyle}>
      <p>There is no scheduled event. We'll provide a notice when events are available.</p>
    </div>
<button onClick={() => navigate('/games')} color="white">
            
              <h3 style={{ color: 'white', textAlign: 'center', lineHeight: '1.5' }}> Games</h3>
        
          </button>

          <button onClick={() => navigate('/tools')} color="white">
            
              <h3 style={{ color: 'white', textAlign: 'center', lineHeight: '1.5' }}> Tools</h3>
        
          </button>

          <button onClick={() => navigate('/jobs')} color="white">
            
              <h3 style={{ color: 'white', textAlign: 'center', lineHeight: '1.5' }}> Jobs</h3>
        
          </button>
     </div>

     
       )}
    </div>
  );


  /* return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      {isLoading ? (
  <LoadingSpinner />
) : (
      <iframe
        src="https://www.spcommunity.org.za/events"
        style={{ width: "100%", height: "100vh", border: "none", overflow: "auto" }}
        title="Contact Form"
        onLoad={() => setIsLoading(false)} // Hide spinner when iframe loads
      ></iframe>
       )}
    </div>
  ); */

  
};

export default ContactForm;
